import { AxiosError } from "axios";
import { VideoCommentErrorDTO } from "../Models/DTOs/VideoCommentsDTO";
import { createCommentsApi } from "./CommentsAPI";

export {
    getVideoCommentErrorCode,
    getVideoCommentErrorStatus,
    isVideoCommentRequestCancelled,
} from "./CommentsAPI";

export const videoCommentsApi = createCommentsApi("video");
export const {
    getComments: GetVideoComments,
    getReplies: GetVideoCommentReplies,
    createComment: CreateVideoComment,
    editComment: EditVideoComment,
    deleteComment: DeleteVideoComment,
    setVote: SetVideoCommentVote,
    removeVote: RemoveVideoCommentVote,
    reportComment: SubmitVideoCommentReport,
    getModerationReports: GetVideoCommentModerationReports,
    resolveReport: ResolveVideoCommentReport,
    pinComment: PinVideoComment,
    unpinComment: UnpinVideoComment,
} = videoCommentsApi;

export type VideoCommentAxiosError = AxiosError<VideoCommentErrorDTO>;
